import { FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Routes from '@/router/Routes';
import Middleware from '@/router/middleware/index';
import { useAuthContext } from '@/context/AuthContext';

/**
 * Middleware that checks if the user is a company admin
 * Redirects to company login page if not authenticated as company admin
 */
const AuthCompanyAdmin: FC = () => {
  const { session, isLoading } = useAuthContext();

  // Check if user has company admin role in user_metadata or app_metadata
  const isCompanyAdmin = 
    session?.user?.user_metadata?.role === 'company_admin' ||
    session?.user?.app_metadata?.role === 'company_admin';

  return (
    <Middleware isLoading={isLoading}>
      {isCompanyAdmin ? <Outlet /> : <Navigate to={Routes.COMPANY__LOGIN} />}
    </Middleware>
  );
};

export default AuthCompanyAdmin;

